require('../../ui/src/styles/common.scss');
require('../../ui/src/styles/dy-ui.scss');
require('./recruit-index-template.scss');

// import routeModule from 'angular-route';
// import 'angular'

window.module = angular.module('RCP', [
    'COM'
]);

require('./service/space.js');

require('./directive/common-modal/common-modal');
require('./directive/default-img/default-img');
require('./directive/max-length-limit/max-length-limit');
require('./directive/tail-bar/tail-bar');
require('./directive/fixed-toolbar/fixed-toolbar-dir');
require('./directive/ng-time-ago/ng-time-ago');
require('./directive/datetime/datetime-dir');
require('./directive/upload/upload-plugin');
require('./directive/upload/ul');
require('./directive/upload/ulc');

angular.module('RCP').controller('recruitIdxCtrl', function ($scope, $element, service, $timeout, chatGlobal) {
    console.log('this is recruitIdxCtrl');
    let d = $scope.d = {};
    let f = $scope.f = {};

    /**
     * 跳到指定的部分
     * @param seg
     */
    f.jump = (seg) => {
        let curObj = $element.find('#rct-' + seg + '-1510828044038');
        let curObjTop = curObj.offset().top;
        angular.element('html, body').animate({scrollTop: curObjTop});
    };

    /**
     * 登录窗
     */
    f.toLogin = () => {
        f.closeWin();
        service.common.toLogin();
    };

    /**
     * 关闭提示弹窗
     */
    f.closeWin = () => {
        d.tipDialog.close();
    };

    /**
     * 提示弹窗中的去注册
     */
    f.goReg = () => {
        f.jump('reg');
        f.closeWin();
    };

    f.seeRsm = (rsmId) => {
        var urlTemp = rcpAid.getUrl('简历预览', {'osPre': true, 'rid': rsmId});
        window.open(urlTemp);
    };

    /**
     * 提示弹窗
     * @param dataTip
     */
    f.dialogOpen = (dataTip) => {
        console.log('this is dialogOpen');
        d.tipDialog.tipInfo = dataTip;
        d.tipDialog.open();
    };

    f.seeAgreement = () => {
        var urlTemp = DYCONFIG.sso.rUrl + 'sso/agreement.html';
        window.open(urlTemp);
    };

    function checkLogin() {
        $scope.$on('login', function (rs, data) {
            console.log('this is login broadcast', data);
            if (data) {
                window.location.href = '/recruit.html#!/discover'
            }
            // 即时通讯初始化
            $timeout(function () {
                console.log('this is chat init');
                if (!d.isIE9 && chatGlobal && typeof chatGlobal.init === 'function') {
                    var chatParam = data && data.uid ? '' : {anonymous: 1};
                    chatGlobal.init(chatParam);
                }
            });
        });
    }

    function iframeInit() {
        console.log('this is iframInit');
        var url = DYCONFIG.sso.rUrl + 'sso/recruit-register.html';
        $element.find('#rct-reg-1510828044038')[0].src = url;
    }

    function init() {
        d.verifyImg = '';
        d.mark = '';

        d.password = '';
        d.phone = '';
        d.vefyCode = '';
        d.judgeNum = '';

        // 0: 不进行校验 ， 1： 进行手机号码，图片验证码的校验， 2： 全部进行校验
        d.checking = 0;

        d.tipDialog = {
            title: '',
            hide: 'footer',
            hideBtn: true
        };

        d.timing = 0;

        d.isIE9 = rcpAid.isIE(9, 9);

        iframeInit();

        checkLogin();
    }

    init();
});


// WEBPACK FOOTER //
// ./src/recruit/src/recruit-index-template.js